import { PartnerFields } from 'clickNgo/entities/partner/configs'

export const fieldsForCopy = [
  {
    legal: PartnerFields.legalAddressLine1.field,
    basic: PartnerFields.addressLine1.field,
  },
  {
    legal: PartnerFields.legalAddressLine2.field,
    basic: PartnerFields.addressLine2.field,
  },
  {
    legal: PartnerFields.legalAddressLine3.field,
    basic: PartnerFields.addressLine3.field,
  },
  {
    legal: PartnerFields.legalCountry.field,
    basic: PartnerFields.country.field,
  },
  {
    legal: PartnerFields.legalState.field,
    basic: PartnerFields.state.field,
  },
  {
    legal: PartnerFields.legalCity.field,
    basic: PartnerFields.city.field,
  },
  {
    legal: PartnerFields.legalZipCode.field,
    basic: PartnerFields.zipCode.field,
  },
]
